import React from 'react';
import { Stack } from '@moda/om';
import { LineItem } from '../../../hooks/useCart/cart.rest';
import { formatPrice } from '../../../lib/formatPrice';
import { getRoundedMarkdownPercent } from '../../../lib/variantUtils/getRoundedMarkdownPercent';
import { EstimatedVatLink } from '../../EstimatedVatLink';

import './LineItemPrice.scss';

type Props = {
  direction: 'vertical' | 'horizontal';
  alignItems: 'flex-start' | 'flex-end';
  item: LineItem;
};

export const LineItemPrice: React.FC<Props> = ({
  direction,
  alignItems,
  item: {
    attributes: {
      isTrunkshow,
      isPreorder,
      prices: { originalPrice, currentPrice: currentSinglePrice, depositPrice, isDiscounted },
      quantity,
      vatOnProductPrice,
      promotionApplicableMessage
    }
  }
}) => {
  // TODO: this should be calculated correctly on the back-end
  const currentPrice = {
    ...currentSinglePrice,
    price: quantity * Number(currentSinglePrice.price)
  };

  const markdownPercent = getRoundedMarkdownPercent({
    currentPrice: Number(currentPrice.price),
    originalPrice: Number(originalPrice.price)
  });

  const promoApplied =
    promotionApplicableMessage && promotionApplicableMessage.toLowerCase() === 'promo applied';

  return (
    <Stack space={1} alignItems={alignItems}>
      <Stack className="LineItemPrice" space={1} direction={direction} data-testid="lineItemPrice">
        {(isDiscounted || promoApplied) && (
          <div className="LineItemPrice__original">
            {formatPrice(originalPrice.currency, originalPrice.price)}
          </div>
        )}
        <div>{formatPrice(currentPrice.currency, currentPrice.price)}</div>
        {(isTrunkshow || isPreorder) && (
          <div>({formatPrice(depositPrice.currency, depositPrice.price)} Deposit)</div>
        )}
        {isDiscounted && (
          <div className="LineItemPrice__markdown-percent">Save {markdownPercent}%</div>
        )}
      </Stack>
      <EstimatedVatLink currentPrice={currentPrice} vatPrice={vatOnProductPrice} />
    </Stack>
  );
};
